import {
  Grid,
  Modal,
  Box,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

type ImagePreviewProps = {
  image: {
    url1_1: string;
    url4_3: string;
    url16_9: string;
  };
};

const ImagePreview = ({ image }: ImagePreviewProps) => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState({ url: '', aspect: 1 });

  const handleOpen = (imageUrl: string, aspect: number) => {
    setSelectedImage({ url: imageUrl, aspect });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Grid
        container
        spacing={3}
        sx={{
          pt: 5,
          justifyContent: "center"
        }}>
        <Grid >
          {image?.url1_1 && (
            <img
              width={150}
              height={150}
              src={image.url1_1}
              alt=""
              onClick={() => handleOpen(image.url1_1, 1)}
            />
          )}
        </Grid>
        <Grid >
          {image?.url4_3 && (
            <img
              width={(150 * 4) / 3}
              height={150}
              src={image.url4_3}
              alt=""
              onClick={() => handleOpen(image.url4_3, 4 / 3)}
            />
          )}
        </Grid>
        <Grid >
          {image?.url16_9 && (
            <img
              width={(150 * 16) / 9}
              height={150}
              src={image.url16_9}
              alt=""
              onClick={() => handleOpen(image.url16_9, 16 / 9)}
            />
          )}
        </Grid>
      </Grid>
      <Dialog open={open} onClose={handleClose} maxWidth="lg">
        <DialogContent>
          <Grid container sx={{
            justifyContent: 'center'
          }}>
            <Box
              sx={{
                position: 'absolute',
                top: '0%',
                right: '10px',
              }}
            >
              <IconButton
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  background: 'rgba(255,255,255,0.7)',
                }}
                onClick={handleClose}
              >
                <CloseIcon color="error" />
              </IconButton>{' '}
            </Box>
            <Grid >
              <img
                height={500}
                width={500 * selectedImage.aspect}
                style={{ objectFit: 'cover' }}
                src={selectedImage.url}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImagePreview;
